import { ConfigurationType } from '../types/ConfigurationType'

const config: ConfigurationType = {
    scope: process.env.REACT_APP_MSAL_CLIENT_SCOPE || '',
    redirectUrl: process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3000',
    clientAuthority: process.env.REACT_APP_MSAL_AUTHORITY || '',
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
    apiBaseUrl: process.env.NODE_ENV === 'production' ? window.location.origin.replace('fmcore.sainsburys.co.uk', 'wa-fmreporting-prod-admin.azurewebsites.net').replace('admin', 'api') + '/api/' : 'http://localhost:5109/api/'
}

export { config }